import styled from 'styled-components/native';

export const ScrollView = styled.ScrollView`
  padding-horizontal: 16px;
`;

export const Descp = styled.Text`
  font-family: ${({ theme }) => theme.fontFamily.core.w600};
  color: ${({ theme }) => theme.color.base.c7};
  font-size: 16px;
  line-height: 24px;
  margin-vertical: 16px;
`;

export const Image = styled.Image`
  margin-vertical: 32px;
  width: 100%;
  height: 140px;
  border-radius: 15px;
`;

export const HistoryView = styled.View`
  align-items: flex-start;
`;

export const ModulesView = styled.View`
  padding-top: 16px;
`;

export const FormatsRow = styled.View`
  padding-vertical: 24px;
  flex-direction: row;
`;

export const FormatImage = styled.Image`
  width: 40px;
  height: 60px;
  margin-right: 48px;
`;

export const Footer = styled.View`
  padding-vertical: 24px;
`;
